export default {
  /** 原材料主数据-获取列表 */
  LIST_FUND_COLLECTION_REGISTER_BY_PAGE: '/produce/pdProduct/queryPage',

  /** 原材料主数据-原料编号列表-文本框模糊查询 */
  PD_SELECT_OPTION: '/produce/pdProduct/querySelectOPtion',

  /** 原材料主数据-校准名称列表-文本框模糊查询 */
  PD_SELECT_OPTION_ALIAS: '/produce/pdProductAlias/querySelectOPtion',

  /** 原材料主数据-保存 */
  ADD_PRODUCT: '/produce/pdProduct/save',

  /** 原材料主数据-删除 */
  DELETE_PRODUCT: '/produce/pdProduct/delete',

  /** 原材料主数据-导入 */
  IMPORT_MATERIAL: '/produce/pdProduct/importExcelByMaterial',

  /** 原材料主数据-导出 */
  EXPORT_MATERIAL: '/produce/pdProduct/exportExcelMaterial',

  /** 产品主数据-导入 */
  IMPORT_PRODUCT: '/produce/pdProduct/importExcelByProduct',

  /** 产品主数据-导出 */
  EXPORT_PRODUCT: '/produce/pdProduct/exportProductExcel',

  /** 原材料主数据-详情 */
  DETAIL_PRODUCT: '/produce/pdProduct/queryById',
  /** 原材料主数据-依据主料辅料获取原料编码和名称 */
  LIST_PRODUCT_CODES: '/produce/pdProduct/queryProductCodes',
  /** 原材料主数据-查询所有的原料编号和原料名称 */
  LIST_PRODUCT_CODE: '/produce/pdProduct/queryProductcode',
};
